<div [formGroup]="form">
  <h3 class="mat-h2 text-small-caps color-primary">{{ 'COMPANY_INFORMATION' | translate }}</h3>
  <mtn-text-field
    [form]="form"
    controlName="name"
    [placeholder]="'NAME' | translate"
    [isRequired]="true">
  </mtn-text-field>

  <mtn-text-area-field
    [form]="form"
    controlName="description"
    [placeholder]="'DESCRIPTION' | translate"
    [maxLength]="255">
  </mtn-text-area-field>

  <h3 class="mat-h2 text-small-caps color-primary">{{ 'LICENSE_INFORMATION' | translate }}</h3>
  <mtn-license-types-select
    [form]="form"
    controlName="type"
    [isRequired]="true">
  </mtn-license-types-select>

  <div fxLayout="row" fxLayoutGap="15px">
    <mtn-datepicker-field
      [form]="form"
      controlName="startDate"
      [placeholder]="'START_DATE' | translate"
      [isRequired]="true">
    </mtn-datepicker-field>

    <mtn-datepicker-field
      [form]="form"
      controlName="expirationDate"
      [placeholder]="'EXPIRATION_DATE' | translate">
    </mtn-datepicker-field>
  </div>
</div>
